import React from 'react';
import { ButtonStyles } from './Button.styles';
const Button = ({ branding, className, disabled, icon, title, toggleOn = false, type = 'button', onClick, }) => {
    return (React.createElement(ButtonStyles.Button, { className: className, branding: branding, disabled: disabled, type: type, onClick: onClick, "data-toggle-on": toggleOn, "aria-label": `click to open ${title}` },
        React.createElement(ButtonStyles.Text, null, title),
        icon && React.createElement(ButtonStyles.IconWrapper, null, icon)));
};
const LinkButton = ({ branding, className, href, icon, target = '_self', title, }) => {
    return (React.createElement(ButtonStyles.Button, { className: className, as: "a", branding: branding, href: href, target: target, "aria-label": `a link to the page ${title}` },
        React.createElement(ButtonStyles.Text, null, title),
        icon && React.createElement(ButtonStyles.IconWrapper, null, icon)));
};
export { Button as default, LinkButton };
